import {
    links,
    routeNames,
    titles
} from '@app/router/constants';
import {
    chainGuards,
    getDefaultLayout, guestsOnly,
} from '@app/router/utils';
import { Route } from 'vue-router';
import ActivateAccountPage from '@pages/ActivateAccountPage.vue';
import RegisterPage from '@pages/RegisterPage.vue';
import PasswordRecoveryPage from '@pages/PasswordRecoveryPage.vue';

export default [
    {
        path: links.passwordRecovery,
        name: routeNames.passwordRecovery,
        components: getDefaultLayout(PasswordRecoveryPage),
        meta: {
            title: titles.passwordRecovery
        },
        beforeEnter: chainGuards(
            [
                guestsOnly(),
                (to: Route, from: Route, next: Function) => {
                    if (!to.query.passwordToken) {
                        next({ path: links.landing, replace: true });
                    } else {
                        next();
                    }
                }
            ]
        )
    },
    {
        path: links.register,
        name: routeNames.register,
        components: getDefaultLayout(RegisterPage),
        meta: {
            title: titles.register
        },
        beforeEnter: guestsOnly()
    },
    {
        path: links.activateAccount,
        name: routeNames.activateAccount,
        components: getDefaultLayout(ActivateAccountPage),
        meta: {
            title: titles.activateAccount
        },
        beforeEnter: chainGuards(
            [
                guestsOnly(),
                (to: Route, from: Route, next: Function) => {
                    if (!to.query.activationCode) {
                        next({ path: links.landing, replace: true });
                    } else {
                        next();
                    }
                }
            ]
        )
    },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/router/routes/register.ts